// Queries and mutations for the Rewards module
import { gql } from 'apollo-boost';

const rewardCardQuery = `
id
name
chapterWinnerOnly
price
pack
skill
power
speed
url
authorName
`;


export const GET_REWARD_CARDS = gql`
query rewardCards($pack: String) {
    rewardCards(pack: $pack) {
       ${rewardCardQuery}
    }
}
`;

export const GET_REWARD_CARDS_BY_ID = gql`
    query rewardCardsById($rewardCardPackId: ID) {
        rewardCardsById(rewardCardPackId: $rewardCardPackId) {
            ${rewardCardQuery}
        }
    }
`

export const GET_REWARDS_CARDS_PACKS = gql`
query rewardCardPacks {
    rewardCardPacks {
        id
        name
        published
        createdAt
        coverImageUrl
        previewImageUrl
        designImageUrl
    }
}
`

export const GET_REWARD_CARD_PACK_BY_NAME = gql`
    query rewardCardPackByName($name: String!) {
        rewardCardPackByName(name: $name) {
            coverImageUrl
            createdAt
            designImageUrl
            id
            name
            previewImageUrl
            published
        }
    }
`

export const GET_REWARD_CARD_PACK_BY_ID = gql`
    query rewardCardPackById($rewardCardPackId: ID!) {
        rewardCardPackById(rewardCardPackId: $rewardCardPackId) {
            coverImageUrl
            createdAt
            designImageUrl
            id
            name
            previewImageUrl
            published
        }
    }
`

export const BUY_REWARD_CARD = gql`
mutation buyRewardCard($studentId: ID!, $rewardCardId: ID!) {
    buyRewardCard(studentId: $studentId, rewardCardId: $rewardCardId) {
        errors
        student {
            id
            availableGems
            cardsCollected
            rewardCardPackStats
            studentRewardCards {
                id
                rewardCard {
                    id
                    chapterWinnerOnly
                    pack
                }
            }
      }
    }
}
`;

export const REWARD_CARD_PACK_STASTS = gql`
query currentStudent {
    currentStudent {
        id
        rewardCardPackStats
    }
}
`

